/**
 * Utility functions for managing Favorite Users stored in localStorage
 */

const FAVORITE_USERS_KEY = "admin_favorite_users";

export const getFavoriteUsers = () => {
  try {
    const raw = localStorage.getItem(FAVORITE_USERS_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch (err) {
    console.warn("Failed to load favorite users from localStorage:", err);
    return [];
  }
};

export const isFavoriteUser = (userId) => {
  if (!userId) return false;
  const list = getFavoriteUsers();
  return list.some((u) => String(u.id || u.userId) === String(userId));
};

export const toggleFavoriteUser = (user) => {
  if (!user || (!user.id && !user.userId)) return false;
  const id = String(user.id || user.userId);
  const list = getFavoriteUsers();
  const existingIdx = list.findIndex((u) => String(u.id || u.userId) === id);

  let updatedList;
  let isNowFavorite = false;

  if (existingIdx >= 0) {
    // Remove from favorites
    updatedList = list.filter((u) => String(u.id || u.userId) !== id);
    isNowFavorite = false;
  } else {
    // Add to favorites (store minimal metadata for fast rendering)
    const userPayload = {
      id: id,
      userId: id,
      firstName: user.firstName || "",
      lastName: user.lastName || "",
      firstNameEn: user.firstNameEn || "",
      lastNameEn: user.lastNameEn || "",
      phone: user.phone || "",
      profileImage: user.profileImage || "",
      role: user.role || "user",
      verifiedId: user.verifiedId || "none",
      activated: !!user.activated,
      lineTitle: user.lineTitle || "",
      lineId: user.lineId || "",
      savedAt: new Date().toISOString(),
    };
    updatedList = [userPayload, ...list];
    isNowFavorite = true;
  }

  try {
    localStorage.setItem(FAVORITE_USERS_KEY, JSON.stringify(updatedList));
    // Dispatch custom event so all open components re-render immediately
    window.dispatchEvent(new Event("favorite_users_updated"));
  } catch (err) {
    console.warn("Failed to save favorite users to localStorage:", err);
  }

  return isNowFavorite;
};

export const removeFavoriteUser = (userId) => {
  if (!userId) return;
  const list = getFavoriteUsers();
  const updatedList = list.filter((u) => String(u.id || u.userId) !== String(userId));
  try {
    localStorage.setItem(FAVORITE_USERS_KEY, JSON.stringify(updatedList));
    window.dispatchEvent(new Event("favorite_users_updated"));
  } catch (err) {
    console.warn("Failed to update favorite users:", err);
  }
};
